var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.865 1.59151C7.53067 1.06675 8.46933 1.06674 9.135 1.59151L13.8017 5.27037C14.2427 5.61801 14.5 6.14859 14.5 6.71015V13.3334C14.5 14.346 13.6792 15.1668 12.6667 15.1668H10.6667C10.0223 15.1668 9.5 14.6444 9.5 14.0001V11.3334C9.5 10.8732 9.12693 10.5001 8.66667 10.5001H7.33493C6.87487 10.5001 6.50181 10.873 6.50159 11.333L6.50032 14.0007C6.50001 14.6448 5.97777 15.1668 5.33365 15.1668H3.33333C2.32081 15.1668 1.5 14.346 1.5 13.3334V6.71015C1.5 6.14859 1.75735 5.61801 2.19833 5.27037L6.865 1.59151Z",
    fill: "#7F818D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome2);
export default __webpack_public_path__ + "static/media/home-2.4f52cd4399de751bdca1ae7293e5f628.svg";
export { ForwardRef as ReactComponent };